import React, { memo, forwardRef } from "react";
const SvgFactorial = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18 21.49c0 .413-.15.768-.45 1.065A1.406 1.406 0 0116.5 23c-.2 0-.394-.039-.581-.116a1.661 1.661 0 01-.469-.31 1.566 1.566 0 01-.337-.465 1.5 1.5 0 01-.113-.58c0-.414.144-.769.431-1.066.3-.297.656-.445 1.069-.445.4 0 .75.142 1.05.426.3.284.45.633.45 1.046zm-2.625-11.173c0-.271.037-.49.113-.659a1.16 1.16 0 01.3-.406.872.872 0 01.375-.194C16.288 9.02 16.4 9 16.5 9c.087 0 .194.02.319.058.137.026.262.09.375.194a.92.92 0 01.3.406c.087.168.131.388.131.659v7.126c0 .27-.044.497-.131.677a1.097 1.097 0 01-.3.407c-.113.09-.238.155-.375.194a1.62 1.62 0 01-.319.038c-.1 0-.212-.013-.337-.038a1.301 1.301 0 01-.376-.194 1.463 1.463 0 01-.3-.407 1.776 1.776 0 01-.112-.677v-7.126z"
      />
    </svg>
  );
});
SvgFactorial.displayName = "SvgFactorial";
const MemoForwardRef = memo(SvgFactorial);
export default MemoForwardRef;
